<template>
<div>
  <v-app-bar app elevate-on-scroll>
    <v-app-bar-nav-icon @click.native.stop="set_drawer(!drawer)"></v-app-bar-nav-icon>
    <!-- <v-btn
      class="mr-3" elevation="0" small
      @click=""
    >
      <v-icon>
        mdi-dots-vertical
      </v-icon>
    </v-btn> -->
    <v-toolbar-title class="headline text-uppercase">
      <v-img height="40" contain :src="require('../assets/motiplate-logo-colour.png')" ></v-img>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn class="d-none d-sm-flex"
      v-for="item in homeNavLinks"
      v-bind:key="item.link"
      text
      @click="ScrollTo(item.link)"
       :to="'/'+item.link"
    >
      <span class="mr-2">{{ item.text }}</span>
    </v-btn>
    <v-btn class="d-none d-sm-flex" @click="login_dialog({ show: true })" text v-if="!loggedIn">
      <span class="mr-2">Log In</span>
    </v-btn>
    <!-- <v-btn class="d-none d-sm-flex" @click="logout" text v-if="loggedIn">
      <span class="mr-2">Log Out</span>
    </v-btn>
    <v-btn class="d-none d-sm-flex" text to="/account">
      <span class="mr-2">Account</span>
    </v-btn> -->
    <!-- <v-menu left bottom offset-y> -->
          <v-btn dark depressed color="secondary" class="mx-2" to="/dashboard/index" v-if="loggedIn">
            Dashboard
            <v-icon dark right>mdi-view-dashboard</v-icon>
            <!-- <v-icon dark>mdi-chevron-down</v-icon> -->
          </v-btn>
        <!-- </template> -->

        <!-- <v-list>
          <v-list-item
            v-for="n in 5"
            :key="n"
            @click="() => {}"
          >
            <v-list-item-title>Option {{ n }}</v-list-item-title>
          </v-list-item>
        </v-list> -->
        <!-- <v-card
    class="mx-auto"
  >
          <v-list>
            <v-list-item to="/account/Orders">
              <v-list-item-icon>
                <v-icon>mdi-credit-card-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>My subscriptions</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="logout">
            <v-list-item-icon>
                <v-icon>mdi-account-arrow-right</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <template v-slot:append>
            <div class="pa-2">
              <v-btn block>Logout</v-btn>
            </div>
          </template>
  </v-card> -->
      <!-- </v-menu> -->
<v-progress-linear indeterminate absolute bottom :active="pageLoading"></v-progress-linear>
  </v-app-bar>


  <!-- <v-navigation-drawer app v-model="sideNav" class="hidden-sm-and-up" disable-resize-watcher>
    <v-container>
      <v-row
        v-for="(item, i) in homeNavLinks"
        :key="i" align="center" justify="center"
      >
        <v-col class="py-0">
          <v-btn
            text
            width="100%"
            @click="ScrollTo(item.link)"
            :to="'/'+item.link"
          ><span>{{ item.text }}</span></v-btn>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-btn class="d-sm-flex"
            width="100%"
            text
            :to="'/account/orders'"
            @click="$emit('showLogin')"
             v-if="!loggedIn"
          ><span class="mr-2"  >Log In</span></v-btn>
          <v-btn class="d-sm-flex"
            width="100%"
            text
            :to="'/'"
            @click="logout"
             v-if="loggedIn"
          ><span class="mr-2"  >Log Out</span></v-btn>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer> -->
</div>
</template>
<script>
import { types as UserStoreTypes } from "../store/user";
  // Utilities
  import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      loggedIn: false,
      sideNav: false,
      homeNavLinks: [
        { text: 'About', link:'#About' },
        { text: 'Features', link:'#Features' },
        { text: 'Get Motiplate', link:'#Pricing' },
        { text: 'Contact', link:'#Contact' },
      ]
    }
  },
  computed: {
    ...mapState('Ui', ['drawer', 'pageLoading']),
    user() {
      const cur = this.$store.getters[UserStoreTypes.getters.USER];
      return cur;
    }
  },
  watch: {
    user(cur) {
      if (cur !== null && cur !== undefined) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
      //return cur;
    }
  },
  methods: {
    ...mapMutations('Ui', ['set_drawer', 'login_dialog']),
    ScrollTo(link) {      
      this.$vuetify.goTo(link, {
        duration: 500,
        easing: 'easeInOutCubic',
      })
    },
    logout() {
      this.$store.dispatch(UserStoreTypes.actions.LOGOUT)
    }
  }
}
</script>